<basic-input
  [control]="control"
  [label]="label"
  [placeholder]="placeholder"
  [image]="getImage"
  [icon]="icon"
  [iconType]="iconType"
  [id]="id"
  [required]="required"
  (onBlurValueChange)="onBlurEvent($event)"
  (onKeydown)="onKeydownEvent($event)"
  [mode]="mode"
  (onValueChange)="onInput($event); checkLeadingZeros($event)"
  [fieldType]="basicFieldType"
  [allowClearButton]="allowClearButton"
></basic-input>
